import axios from "axios";
import { baseUrl } from "../api/api";

export default async function getLocationService() {
  const response = await axios.get(`${baseUrl}/cbx/services/config`);

  return response.data.data;
}
